import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SkipToContentProps {
  targetId?: string;
  className?: string;
}

export function SkipToContent({ targetId = 'main-content', className }: SkipToContentProps) {
  return (
    <Button
      asChild
      variant="ghost"
      className={cn(
        'fixed left-6 top-6 z-100 pointer-events-none opacity-0',
        '-translate-y-4 transition-all duration-200 ease-out',
        'focus-visible:pointer-events-auto focus-visible:opacity-100 focus-visible:translate-y-0 focus-visible:bg-background',
        className,
      )}
    >
      <a href={`#${targetId}`}>Skip to main content</a>
    </Button>
  );
}
